import { OrganizationDetail } from '../organization/OrganizationDetail';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function OrganizationDetailWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return <OrganizationDetail guid={guid} user={user} zoneContext={zoneContext} />;
}

export default OrganizationDetailWrapper;
